import { Table as o } from "./Table.js";
import { Body as r } from "./Body.js";
import { Header as m } from "./Header.js";
import { Row as t } from "./Row.js";
import { Cell as e } from "./Cell.js";
import { Column as i } from "./Column.js";
const n = Object.assign(o, {
  Body: r,
  Cell: e,
  Column: i,
  Header: m,
  Row: t
});
export {
  n as Table
};
